module.exports = __webpack_public_path__ + "52a69a8babafbb9fb17a51a25e9ccd6b.png";